import { render, staticRenderFns } from "./ClientNotice.vue?vue&type=template&id=c96e83c0&scoped=true&"
import script from "./ClientNotice.vue?vue&type=script&lang=js&"
export * from "./ClientNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96e83c0",
  null
  
)

export default component.exports